"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M43.125 22.5V18.5417C43.125 14.7917 40 11.6667 36.25 11.6667H35.4166V8.95833C35.4166 7.5 34.1666 6.25 32.7083 6.25H14.1666C12.7083 6.25 11.4583 7.5 11.4583 8.95833V11.6667H11.0416C7.29163 11.6667 4.16663 14.7917 4.16663 18.5417V38.75C4.16663 42.7083 7.29163 45.8333 11.0416 45.8333H36.0416C39.7916 45.8333 42.9166 42.7083 42.9166 38.9583V35C44.7916 34.5833 46.0416 32.9167 46.0416 30.8333V26.6667C46.25 24.5833 44.7916 22.9167 43.125 22.5ZM14.5833 9.375H32.2916V11.6667H14.5833V9.375ZM40 38.9583C40 41.0417 38.3333 42.7083 36.25 42.7083H11.25C9.16663 42.7083 7.49996 41.0417 7.49996 38.9583V18.5417C7.49996 16.4583 9.16663 14.7917 11.25 14.7917H36.25C38.3333 14.7917 40 16.4583 40 18.5417V22.2917H31.4583C29.1666 22.2917 27.2916 24.1667 27.2916 26.4583V30.8333C27.2916 33.125 29.1666 35 31.4583 35H40V38.9583ZM43.125 30.8333C43.125 31.0417 43.125 31.0417 43.125 31.25C42.9166 31.6667 42.5 31.875 42.0833 31.875H31.4583C30.8333 31.875 30.4166 31.4583 30.4166 30.8333V26.6667C30.4166 26.0417 30.8333 25.625 31.4583 25.625H42.0833C42.5 25.625 42.9166 25.8333 43.125 26.25C43.125 26.4583 43.125 26.4583 43.125 26.6667V30.8333Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M34.7916 27.0833H32.2916V30.2083H34.7916V27.0833Z",
    fill: fill
  }));
};

exports["default"] = _default;